import { useLazyQuery } from '@apollo/client';
import { Cascader } from 'antd';
import { map } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../../../../../common/constants';
import { ORGANIZATION_INSTRUCTION_TYPE_LIST } from '../setup/graphql/Queries';

const TypeFilter = ({ onChange, projectId }) => {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState([]);
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  const [organizationInstructionTypeList, { loading }] = useLazyQuery(
    ORGANIZATION_INSTRUCTION_TYPE_LIST,
    {
      fetchPolicy: 'network-only',
      onCompleted: () => {},
      onError: () => {},
    },
  );

  const transformDataToCascaderFormat = (data) => {
    return map(data, (item) => {
      const transformedItem = {
        value: item?.name,
        label: item?.name,
      };
      if (item?.children?.length > 0) {
        transformedItem.children = transformDataToCascaderFormat(
          item?.children,
        );
      }

      return transformedItem;
    });
  };

  const flattenDataForMobileView = (data, parentPath = '') => {
    let flattenedOptions = [];

    data?.forEach((item) => {
      const currentPath = parentPath
        ? `${parentPath} >> ${item?.name}`
        : item?.name;

      flattenedOptions.push({
        value: currentPath,
        label: currentPath,
      });

      if (item?.children?.length > 0) {
        const childrenFlattened = flattenDataForMobileView(
          item?.children,
          currentPath,
        );
        flattenedOptions = flattenedOptions?.concat(childrenFlattened);
      }
    });

    return flattenedOptions;
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await organizationInstructionTypeList({
        variables: {
          filter: {
            projectId,
            isDropDown: true,
          },
        },
      });

      if (response?.data?.organizationInstructionTypeList) {
        if (isDesktopViewport) {
          const transformedData = transformDataToCascaderFormat(
            response?.data?.organizationInstructionTypeList,
          );
          setOptions(transformedData);
        } else {
          const flattenedData = flattenDataForMobileView(
            response?.data?.organizationInstructionTypeList,
          );
          setOptions(flattenedData);
        }
      }
    };

    fetchData();
  }, [organizationInstructionTypeList, isDesktopViewport]);

  const handleChange = (value) => {
    setSelectedValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  const filter = (inputValue, path) =>
    path?.some(
      (option) =>
        option?.label?.toLowerCase()?.indexOf(inputValue?.toLowerCase()) > -1,
    );

  return (
    <Cascader
      options={options}
      onChange={handleChange}
      value={selectedValue}
      changeOnSelect
      placeholder="Type"
      loading={loading}
      showSearch={{ filter }}
      className="type-filter-cascader"
      popupClassName="type-filter-cascader-dropdown"
    />
  );
};

export default TypeFilter;
